import React from 'react';
import cd from 'debug';

import { MarketsCount, StreamLink } from 'components';
import './streamMarketCount.scss';

const debug = cd('components:Score');

interface OwnProps {
    topMarketsCount: number;
    streamWithTitle: boolean;
    marketsCount: number | undefined;
    linkToMatch: string | null;
    isResultPage?: boolean;
    isLive: boolean;
    toggleStream?: () => void;
    isViewerOpen: boolean;
    isSportEventViewable: boolean;
}

export default class StreamMarketCount extends React.Component<OwnProps> {
    render() {
        debug('render', this.props);

        const {
            marketsCount,
            linkToMatch,
            streamWithTitle,
            topMarketsCount,
            isResultPage = false,
            isLive,
            isViewerOpen,
            isSportEventViewable,
        } = this.props;

        const hasStreamLink = isSportEventViewable && (!isResultPage || isLive);

        return (
            <div
                styleName="container"
                className="__app-StreamMarketCount-container"
            >
                {hasStreamLink && (
                    <StreamLink
                        linkToMatch={linkToMatch}
                        withTitle={streamWithTitle}
                        onClick={this.props.toggleStream}
                        isViewerOpen={isViewerOpen}
                    />
                )}

                <div styleName="market-count">
                    <MarketsCount
                        marketsCount={marketsCount}
                        topMarketsCount={topMarketsCount}
                        linkToMatch={linkToMatch}
                        isHiddenCount={isResultPage}
                    />
                </div>
            </div>
        );
    }
}
